// lib/localHistory.js
//
// Lightweight, per-browser bridge history. The LIVE architecture has no
// server-side intent store (see lib/bridgeApi.js) — the customer's wallet
// signs everything directly and delivery is observed trustlessly from the
// destination chain. The only durable record of "what did I bridge" is
// therefore (a) the chain itself — burn + fulfill events, always re-
// derivable by anyone — and (b) whatever this browser remembers locally.
//
// This is an honest, scoped simplification: BridgeHistoryPage shows history
// for THIS browser only, not cross-device/cross-browser. A future iteration
// could rebuild full history from chain events keyed by wallet address if
// cross-device history is wanted.

const KEY = 'bridge.localHistory.v1';
const MAX_ENTRIES = 100;

export function loadHistory() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch (_) {
    return [];
  }
}

/** Insert a new entry, or merge into an existing one with the same localId. */
export function recordHistoryEntry(entry) {
  try {
    const all = loadHistory();
    const idx = all.findIndex((e) => e.localId === entry.localId);
    if (idx >= 0) {
      all[idx] = { ...all[idx], ...entry };
    } else {
      all.unshift(entry);
    }
    localStorage.setItem(KEY, JSON.stringify(all.slice(0, MAX_ENTRIES)));
  } catch (_) {
    // localStorage may be blocked (private browsing, quota) — history just
    // won't persist across sessions. Not fatal to the bridge itself.
  }
}
